import api from '../../../api/clinique/_rendez_vous'

// RDV-002 : chaque appel demande une capacité courte à be_config puis appelle la Clinique ; le jeton n'est jamais conservé.
const avec_acces = action => new Promise((resolve, reject) => {
    api.access().then((acces) => {
        action(acces.access_token, acces).then(resolve, reject)
    }, reject)
})

export default {
    // Capacité + annuaire des médecins (libellés administratifs, hors du jeton)
    getAcces() {
        return api.access()
    },
    getReferentiel() {
        return avec_acces(token => api.referentiel(token))
    },
    getProchainPatient(patient_id) {
        return avec_acces(token => api.prochainPatient(patient_id, token))
    },
    getAgenda(data) {
        return avec_acces(token => api.liste(data, token))
    },
    creerRendezVous(data) {
        return avec_acces(token => api.creer(data, token))
    },
    changerStatut(rendez_vous_id, data) {
        return avec_acces(token => api.statut(rendez_vous_id, data, token))
    },
    reprogrammer(rendez_vous_id, data) {
        return avec_acces(token => api.reprogrammer(rendez_vous_id, data, token))
    },
    getRappels(data) {
        return avec_acces(token => api.rappelsListe(data, token))
    },
    enregistrerRappel(rendez_vous_id, data) {
        return avec_acces(token => api.enregistrerRappel(rendez_vous_id, data, token))
    },
    getIndicateurs(data) {
        return avec_acces(token => api.indicateurs(data, token))
    },
    // RDV-006 : { rendez_vous_id, heure: 'HH:MM' } — rendez-vous planifié dont l'heure est à fixer
    fixerHeureRendezVous(data) {
        return avec_acces(token => api.fixerHeure({ rendez_vous_id: data.rendez_vous_id, heure: data.heure }, token))
    }
}
